var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"BaseDataForm"},[(_vm.formReady)?[_c('div',{staticClass:"box-container"},[_vm._t("default")],2)]:[_c('div',[_c('a-alert',{staticStyle:{"text-align":"center"},attrs:{"message":_vm.$t("Загрузка данных"),"type":"info"}})],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }